import { render, staticRenderFns } from "./accountComponent.vue?vue&type=template&id=6a54171d&scoped=true&"
import script from "./accountComponent.vue?vue&type=script&lang=js&"
export * from "./accountComponent.vue?vue&type=script&lang=js&"
import style0 from "./accountComponent.vue?vue&type=style&index=0&id=6a54171d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a54171d",
  null
  
)

export default component.exports